<template>
    <div>
        <section class="breadcrumb-section brand_top_section">
            <div class="container">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item">
                            <router-link to="/">Home</router-link>
                        </li>
                        <li class="breadcrumb-item active" aria-current="page">
                            {{ page_title }}
                        </li>
                    </ol>
                </nav>
                <h2 class="main_title" style="text-align: center">
                    <span>{{ page_title }}</span>
                </h2>
            </div>
        </section>

        <section class="cmn-section brand_page p-0" v-if="banner_image">
            <img :src="banner_image" alt="brand-image" />
        </section>

        <section class="cmn-section brand_section">
            <div class="container">
                <div class="row brand_row">
                    <div
                        v-for="(brand, index) in brand_list"
                        :key="index"
                        class="col-md-3 col-lg-2 col-sm-6 brand_col"
                    >
                        <img :src="brand.logo_file" alt="" />
                        <div class="brand_overlay">
                            <h2 class="overlay_heading">{{ brand.name }}</h2>
                            <!-- <p>(24) Product Avaiable</p> -->
                            <div class="overlay_btn">
                                <router-link
                                    v-if="brand.slug"
                                    :to="{ path: 'brand/' + brand.slug }"
                                    class="view_btn"
                                >
                                    View</router-link
                                >
                                <router-link
                                    v-else
                                    :to="{ path: 'brand/' + brand.id }"
                                    class="view_btn"
                                >
                                    View</router-link
                                >
                                <a
                                    v-if="brand.size_chart_image"
                                    :href="brand.size_chart_image"
                                    target="__blank"
                                    class="size_btn"
                                    >Size Chart</a
                                >
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </section>

        <div class="preloader" v-show="isLoader">
            <div class="preloader-body">
                <svg width="40" height="40" viewBox="0 0 40 40">
                    <polygon
                        class="rect"
                        points="0 0 0 40 40 40 40 0"
                    ></polygon>
                </svg>
            </div>
        </div>
    </div>
</template>

<script>
import ApiService from "@/common/api.service";

export default {
    /* eslint-disable */
    name: "Brands",
    /* eslint-enable */
    components: {},
    data() {
        return {
            page_title: "Brands",
            listConfig: [],
            brand_length: 0,
            brand_list: [],
            banner_image: "",
            isLoader: true
        };
    },
    metaInfo() {
        return {
            title: this.page_title,
            titleTemplate: "%s | Imprintcity",
            meta: [
                {
                    vmid: "title",
                    name: "title",
                    content: "Brands"
                },
                {
                    vmid: "description",
                    name: "description",
                    content: "brands"
                },
                {
                    vmid: "keywords",
                    name: "keywords",
                    content: "brands"
                }
            ]
        };
    },
    mounted() {
        (this.listConfig = {
            offset: 0,
            limit: 10000,
            sortBy: "",
            order: "ASC",
            searchKeyword: ""
        }),
            document.body.classList.remove("bg_primary_light_white");

        this.getBrands();
    },
    methods: {
        getSingleMenu() {
            return new Promise((resolve, reject) => {
                ApiService.post("/get-single-menu", { slug: "brands" })
                    .then(({ data }) => {
                        if (!data.menu_data) {
                            this.$router.push({ name: "404" });
                        }
                        this.listConfig.prod_type_id = data.menu_data.id;
                        this.banner_image = data.menu_data.banner_image;
                        resolve(data);
                    })
                    .catch((response) => {
                        console.log(response);
                        reject(response);
                    });
            });
        },
        getBrands() {
            this.isLoader = true;
            new Promise(() => {
                this.getSingleMenu();
                ApiService.post("/get-brands", this.listConfig)
                    .then(({ data }) => {
                        this.brand_length = data.brands.count;
                        this.brand_list = data.brands.rows;
                        this.isLoader = false;
                    })
                    .catch(({ response }) => {
                        console.log(response.status);
                        this.isLoader = false;
                    });
            });
        }
    }
};
</script>
